<div id="footer" class="footer">
    <p>© 2022, Amazon.com, Inc. or its affiliates</p>
</div>
